import React from 'react'
import OrgInviteDecision from 'src/app/OrgInviteDecision/OrgInviteDecision'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { orgInviteDecisionRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const OrgInviteDecisionAppRoute: AppRoute = {
  id: AppLocation.OrgInviteDecision,
  routeProps: orgInviteDecisionRouteProps,
  component: <OrgInviteDecision />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default OrgInviteDecisionAppRoute
